import { HStack, View } from "native-base";
import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { faPlus } from "../../../assets/consts/faCharCodes";
import Theme from "../../argon-ui/Theme";
import FontAwesomeIcon from "../FontAwesomeIcon";
import Text from "../TextFont";

const AddZoneSpeaker = ({
  allSpeakers,
  slavesList,
  onSubmit,
  masterSmartSpeakerUId,
}) => {
  const filterSpeakers = [...allSpeakers].filter(
    (speaker) =>
      !slavesList?.some((speakerGroup) => speakerGroup == speaker.deviceUId) &&
      speaker.deviceUId !== masterSmartSpeakerUId
  );
  const onSubmitHandler = (slaveDeviceUId) => {
    typeof onSubmit == "function" && onSubmit(slaveDeviceUId);
  };
  return (
    <View>
      {filterSpeakers.map((speaker) => {
        return (
          <TouchableOpacity
            key={speaker.deviceUId}
            style={styles.container}
            onPress={() => {
              onSubmitHandler(speaker.deviceUId);
            }}
          >
            <HStack justifyContent="space-between" alignItems="center">
              <Text>{speaker.deviceName}</Text>
              <View style={styles.addBtn}>
                <FontAwesomeIcon
                  icon={faPlus}
                  size={12}
                  color={Theme.COLORS.PRIMARY}
                />
              </View>
            </HStack>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    padding: 8,
    marginBottom: 5,
    backgroundColor: Theme.COLORS.WHITE,
  },
  addBtn: {
    width: 35,
    height: 35,
    backgroundColor: Theme.COLORS.PRIMARY + "15",
    borderRadius: 10,
    padding: 1,
    justifyContent: "center",
    alignItems: "center",

    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
});
export default AddZoneSpeaker;
